import React from 'react'
import {Route, Redirect} from 'react-router-dom'
import {
	HOME, 
	MANAGE_PROCUREMENTS,
	ADD_PROCUREMENT_DIALOG,
	DELETE_PROCUREMENT_DIALOG,
	EDIT_PROCUREMENT_DIALOG,
	LOGIN
} from '../routes'

import ManageProcurementContainer from '../containers/ManageProcurementContainer'
import AddProcurementDialogContainer from '../containers/AddProcurementDialogContainer'
import DeleteProcurementDialogContainer from '../containers/DeleteProcurementDialogContainer'
import EditProcurementDialogContainer from '../containers/EditProcurementDialogContainer'
import LoginContainer from '../containers/LoginContainer'
import Home from './Home'

const Routes = () => (
	<div>
		<Route path={HOME} component={Home} />
		<Route path={LOGIN} component={LoginContainer} />
		<Route path={MANAGE_PROCUREMENTS} component={ManageProcurementContainer} />
		<Route path={ADD_PROCUREMENT_DIALOG} component={AddProcurementDialogContainer} />
		<Route path={DELETE_PROCUREMENT_DIALOG+":id"} component={DeleteProcurementDialogContainer} />
		<Route path={EDIT_PROCUREMENT_DIALOG+":id"} component={EditProcurementDialogContainer} />
	</div>
)

export default Routes


// WEBPACK FOOTER //
// ./src/components/Routes.js